import React, { useState, useEffect, Fragment } from 'react';
import { Col, Row, Button, Card, CardBody, ListGroup, UncontrolledTooltip } from 'reactstrap';
import moment from 'moment';
import Chip from '@material-ui/core/Chip';
import { faPlus, faMinus, faPhone, faMobileAlt, faAddressCard, faHospital, faCircle, faProcedures, faCrutch, faWheelchair, faHeadSideCough, faPlusSquare, faAmbulance, faLungs, faUser } from "@fortawesome/free-solid-svg-icons";
import Tooltip from '@material-ui/core/Tooltip';
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import IconButton from '@material-ui/core/IconButton';


let openShowMore = false;
let eventShow = false;

const CardMedicalEvent = ({ event, setDataEvent }) => {

  const [color, setColor] = useState('$color-additional');
  const [textColor, setTextColor] = useState('black');
  const [openInfoServices, setOpenInfoServices] = useState(false);
  const [colorRisk, setColorRisk] = useState('#6F6964');
  const listTipoClinica = JSON.parse(sessionStorage.getItem('centroTipos'));
  const customObservation = event.observacion_cita ? event.observacion_cita.length > 60 ? event.observacion_cita.slice(0, 60) : event.observacion_cita : '';

  useEffect(() => {
    eventPriorityVerify(event);
    verifyColorRisk(event)
  }, []);

  const eventPriorityVerify = (event) => {
    switch (event.priority) {
      case 'Reservada':
        setColor('#fd7e14'); //orange
        setTextColor('#6F6964');
        break;
      case 'Cumplida':
        setColor('#28a745');//success
        setTextColor('#6F6964');
        break;
      case 'Incumplida':
        setColor('#f6da6e');; //yellow
        setTextColor('#6F6964');
        break;
      case 'Emergencia':
        setColor('#dc3545');//danger
        setTextColor('#6F6964');
        break;
      case 'Disponible':
        setColor('#70bbfd'); //primary
        setTextColor('#6F6964');
        break;
      case 'Inactiva':
        setColor('#6c757d');//gray
        setTextColor('#6F6964');
        break;
      default:
        setColor('$color-additional');
        setTextColor('#6F6964');
        break;
    }
  };

  const verifyColorRisk = (event) => {
    if (JSON.stringify(event.caidas) === '{}') {
      return setColorRisk('#6F6964')
    } else if (event.caidas !== null && event.caidas !== undefined) {
      switch (event.caidas.riesgo) {
        case 'Bajo':
          setColorRisk('#40F400')
          break;
        case 'Alto':
          setColorRisk('#F71C06')
          break;
        case 'Medio':
          setColorRisk('#F7EF06')
          break;

        default:
          setColorRisk('#6F6964')
          break;
      }
    } else {
      return setColorRisk('#6F6964')
    }
  }

  const clickEvent = (opt) => {
    switch (opt) {
      case 1://Cita Medica
        if (openShowMore == false && eventShow == false) {
          setDataEvent(event)
        }
        else {
          if (eventShow == false) {
            openShowMore = false;
          }
          eventShow = false;
          //setOpenInfoServices(true)
        }
        break;
      case 2://Ver Mas
        eventShow = true;
        openShowMore = true;
        setOpenInfoServices(true)
        break;
      case 3://Ver Menos
        eventShow = true;
        openShowMore = false;
        setOpenInfoServices(false)
        break;
    }
  }

  return (
    <Fragment>
      <Card style={{ border: `solid ${color}`, cursor: 'pointer' }} className="card-button-calendar" onClick={() => clickEvent(1)}>
        <Row>
          <Col xs={12} sm={12} md={3}>
            <div className="card-calendar-hour">
              <h4 style={{ color: textColor }}>&nbsp;&nbsp; {moment(event.start).format("h:mm a")} - {moment(event.end).format("h:mm a")}</h4>


              <p className='card-calendar-aditional-info'>

                <label style={{ fontSize: 9 }}>Tipo de Atención <b>
                  <br />
                  {event.nombre_atencion}</b></label>


                <br />
                {JSON.stringify(event.caidas) === '{}' ?
                  null
                  : event.caidas !== null && event.caidas !== undefined ?
                    (<Fragment>
                      <FontAwesomeIcon icon={faCircle} style={{ color: colorRisk }} /> <span>Riesgo de caída: <b>{event.caidas.riesgo}</b></span>
                    </Fragment>)
                    : null
                }
                {
                  JSON.stringify(event.requerimientos_especiales) === '{}' ?
                    null :
                    event.requerimientos_especiales !== null && event.requerimientos_especiales !== undefined ?
                      (<Fragment>
                        <br></br>
                        <span>Requerimientos Especiales:</span>
                        <br></br>
                        {event.requerimientos_especiales.hospitalizado != undefined && event.requerimientos_especiales.hospitalizado != false ?
                          <FontAwesomeIcon icon={faPlusSquare} style={{ marginLeft: 3, color: '#1086e0' }} />
                          : null
                        }
                        {event.requerimientos_especiales.muletas != undefined && event.requerimientos_especiales.muletas != false ?
                          <FontAwesomeIcon icon={faCrutch} style={{ marginLeft: 3, color: '#1086e0' }} />
                          : null
                        }
                        {event.requerimientos_especiales.sillas != undefined && event.requerimientos_especiales.sillas != false ?
                          <FontAwesomeIcon icon={faWheelchair} style={{ marginLeft: 3, color: '#1086e0' }} />
                          : null
                        }
                        {event.requerimientos_especiales.sintomas_respiratorios != undefined && event.requerimientos_especiales.sintomas_respiratorios != false ?
                          <FontAwesomeIcon icon={faHeadSideCough} style={{ marginLeft: 3, color: '#1086e0' }} />
                          : null
                        }
                        {event.requerimientos_especiales.oxigeno != undefined && event.requerimientos_especiales.oxigeno != false ?
                          <FontAwesomeIcon icon={faLungs} style={{ marginLeft: 3, color: '#1086e0' }} />
                          : null
                        }
                        {event.requerimientos_especiales.camilla != undefined && event.requerimientos_especiales.camilla != false ?
                          <FontAwesomeIcon icon={faProcedures} style={{ marginLeft: 3, color: '#1086e0' }} />
                          : null
                        }
                        {event.requerimientos_especiales.ambulancia != undefined && event.requerimientos_especiales.ambulancia != false ?
                          <FontAwesomeIcon icon={faAmbulance} style={{ marginLeft: 3, color: '#1086e0' }} />
                          : null
                        }
                        {event.requerimientos_especiales.otro != undefined && event.requerimientos_especiales.otro != false ?
                          <span style={{ marginLeft: 3, color: '#1086e0' }}> - {event.requerimientos_especiales.otroReq}</span>
                          : null
                        }
                        {event.requerimientos_especiales.ninguno != undefined
                          && event.requerimientos_especiales.ninguno != false
                          && event.requerimientos_especiales.otro == false
                          && event.requerimientos_especiales.ambulancia == false
                          && event.requerimientos_especiales.camilla == false
                          && event.requerimientos_especiales.oxigeno == false
                          && event.requerimientos_especiales.sintomas_respiratorios == false
                          && event.requerimientos_especiales.sillas == false
                          && event.requerimientos_especiales.muletas == false
                          && event.requerimientos_especiales.hospitalizado == false ?
                          <span style={{ marginLeft: 3, color: '#1086e0' }}>Ninguno</span>
                          : null
                        }
                      </Fragment>)
                      : null
                }
              </p>
            </div>
          </Col>
          <Col className="d-none d-md-block" xs={12} sm={12} md={4}>
            <span style={{ color: textColor }}>
              <b>Paciente: </b>
              {event.nombre_paciente != "" && event.nombre_paciente != undefined && event.nombre_paciente != null
                ? (
                  <Fragment>
                    {/* <button className={event.aplicativo_migrado ? "patient-migrated patient-migrated--new" : 'icon-patient'}>
                      <div className={event.aplicativo_migrado ? "patient-migrated-new-label" : ''}>
                        <FontAwesomeIcon icon={faUser} id={event.aplicativo_migrado ? "setPatient" : "none"} />
                        <div />
                        {event.aplicativo_migrado ?
                          <UncontrolledTooltip placement="center" target="setPatient">
                            Paciente migrado desde otro aplicativo
                          </UncontrolledTooltip>
                          : null}
                      </div>
                    </button> */}
                    {event.aplicativo_migrado ?
                      <Fragment>
                        <span style={{ color: '#e0536f' }} id={event.aplicativo_migrado ? "setPatient" : "none"}><FontAwesomeIcon icon={faUser} style={{ color: '#e0536f' }} /> {event.nombre_paciente}</span>
                        <UncontrolledTooltip placement="center" target="setPatient">
                          Paciente migrado desde otro aplicativo
                        </UncontrolledTooltip>
                      </Fragment>
                      :
                      <span style={{ color: textColor }}><FontAwesomeIcon icon={faUser} /> {event.nombre_paciente}</span>
                    }
                    <p style={{ color: textColor, marginTop: 2 }}><FontAwesomeIcon icon={faAddressCard} /> {event.tip_documento} {event.num_documento} - {event.sexo} |
                      {
                        event.acronimo_estudio == null || event.acronimo_estudio == undefined ? <><b> Régimen:</b> {event.regimen}</> : null
                      }
                    </p>
                    <span><FontAwesomeIcon icon={faPhone} /> {event.telefono} - <FontAwesomeIcon icon={faMobileAlt} /> {event.celular} | <FontAwesomeIcon icon={faHospital} /> <b>{event.espacio}</b> </span>
                    <br></br>

                    {
                      event.acronimo_estudio == null || event.acronimo_estudio == undefined ?
                        <span><b>Cliente:</b> {event.nombre_tercero}</span> :
                        <span><b>Patrocinador:</b> {event.nombre_tercero}</span>
                    }
                    <hr style={{ color: color, width: '80%', height: 3, margin: '2px 0px 2px 0px' }}></hr>
                  </Fragment>
                )
                : "Disponible"}
            </span>

            <p style={{ color: textColor, padding: 0, marginTop: 5 }}>
              <b>Profesional: </b>{event.nombres || event.nombre}
            </p>
          </Col>
          {
            event.priority !== "Disponible" ?
              <Col className="d-none d-md-block" xs={12} sm={12} md={5}>
                <div className='flex-column-bet-elem' style={{ height: '100%' }}>
                  <div>
                    {
                      event.acronimo_estudio == null || event.acronimo_estudio == undefined ?

                        <p style={{ color: textColor, textDecoration: 'none' }}>
                          <b>{event.servicios !== null && event.servicios !== undefined ? "Servicios:" : null}  </b>
                          {event.servicios !== null && event.servicios !== undefined ?
                            event.servicios.map((servicio, index) => {
                              if (openShowMore == false && index <= 1) {
                                return <li key={index} style={{ listStyle: 'none' }}>{servicio.codigo} - {servicio.nombre}</li>
                              } else if (openShowMore == true) {
                                return (
                                  <Fragment>
                                    <li key={index} style={{ listStyle: 'none' }}>{servicio.codigo} - {servicio.nombre}</li>
                                  </Fragment>
                                )
                              }
                            })
                            :
                            null
                          }
                          {event.servicios !== null && event.servicios !== undefined ?
                            openInfoServices == false && event.servicios.length >= 3 ?
                              <Tooltip
                                title="Ver más Servicios"
                                style={{ zIndex: 2, pointerEvents: 'none', cursor: 'pointer' }}
                              >
                                <IconButton aria-label="ver_mas_servicios" size="small" onClick={() => clickEvent(2)}
                                  style={{ fontSize: 9 }}>
                                  <FontAwesomeIcon icon={faPlus} />
                                </IconButton>
                              </Tooltip>
                              : event.servicios.length >= 3 ?
                                <Tooltip
                                  title="Ver menos"
                                  style={{ zIndex: 2, pointerEvents: 'none', cursor: 'pointer' }}
                                >
                                  <IconButton aria-label="ver_mas_servicios" size="small" onClick={() => clickEvent(3)}
                                    style={{ fontSize: 9 }}>
                                    <FontAwesomeIcon icon={faMinus} />
                                  </IconButton>
                                </Tooltip>
                                : null
                            : null
                          }
                        </p> :

                        <p style={{ color: textColor, textDecoration: 'none' }}>
                          <b>{event.servicios !== null && event.servicios !== undefined ? "Visita:" : null}  </b>
                          <li key={0} style={{ listStyle: 'none' }}>{event.acronimo_estudio + " - " + event.nombre_visita}</li>
                        </p>
                    }
                  </div>

                  <div>
                    <p>{customObservation}</p>
                  </div>
                </div>
              </Col>
              : null
          }
        </Row>
      </Card>
      <span class="separator-card-medical"></span>
    </Fragment>
  );
};

export default CardMedicalEvent;
